import * as React from 'react';
import FieldHandler from '../../../models/interfaces/FieldHandler';
import SelectField from '../../common/form-controls/SelectField'; 
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';

interface PORTypeInputProps {
	scope:  FieldHandler<string>;
}

interface PORTypeInputState {}

export class PORTypeInput extends React.Component<PORTypeInputProps, PORTypeInputState> {

	scopeOptions = () => {
		return [
			{ value: PortOpeningRequestsDirection.SubscriptionToOnPrem.name, text: 'Subscription <-> ExxonMobil Network' },
			{ value: PortOpeningRequestsDirection.SubscriptionToInternet.name, text: 'Subscription -> Internet' }
		];
	};

	render() {
		return (
			<SelectField
				label="Scope"
				className="full-width"
				options={this.scopeOptions()}
				{...this.props.scope}
			/>
		);
	}
}
